import FeatSDKV2 from 'api/version2';
import { createEffect } from 'effector';

export const getPromotionsByCatalogIdFx = createEffect(
  FeatSDKV2.promotions.getPromotionsByCatalogId,
);
